import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContentBlock } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ContentBlocksService {
  constructor(
    private http: HttpClient,
    @Optional()
    @Inject('BASE_URL')
    private BASE_URL: string
  ) {}

  getBlocksByPage(pageId: number) {
    return this.http.get<ContentBlock[]>(`${this.BASE_URL}api/pages/${pageId}/content-blocks`);
  }
}
